// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Фон */
.overlay-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;
}

/* Контейнер оверлея */
.overlay-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1001;
  width: min(90vw, 1100px);
  height: min(80vh, 700px);
  background: #111;
  color: #fff;
  border-radius: 10px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  overflow: hidden;
}

/* Кнопка закрытия */
.close-btn {
  position: absolute;
  top: 8px;
  right: 10px;
  border: none;
  background: transparent;
  color: #ccc;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
}

.close-btn:hover {
  color: #fff;
}

/* Область видео */
.video-wrapper {
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
  background: #000;
  position: relative;
  padding: 40px 16px 16px; /* место для кнопки закрытия */
}

/* Видео заполняет, сохраняя пропорции */
video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}

/* Загрузка/ошибки */
.loading, .error {
  position: absolute;
  bottom: 12px;
  left: 16px;
  right: 16px;
  padding: 8px 12px;
  border-radius: 6px;
  backdrop-filter: blur(4px);
  background: rgba(0, 0, 0, 0.45);
  font-size: 14px;
}

.spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.25);
  border-top-color: #fff;
  border-radius: 50%;
  margin-right: 8px;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 600px) {
  .overlay-container {
    width: 96vw;
    height: 70vh;
    border-radius: 8px;
  }
  .video-wrapper {
    padding-top: 36px;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
